import service from "@/plugins/request";

// 获取卡池分类列表
export function apiGetCardPoolKindsList() {
  return service({
    url: "/v1/cardPoolKind/query-list",
    method: "get"
  });
}

// 获取卡池列表
export function apiGetCardPoolList(params) {
  return service({
    url: "/v1/cardPool/query-list",
    method: "get",
    params: params
  });
}

// 获取卡池详情
export function apiGetCardPoolDetail(params) {
  return service({
    url: "/v1/cardPool/detail",
    method: "get",
    params: params
  });
}

// 获取活动列表
export function apiGetActivityList(params) {
  return service({
    url: "/v1/activity/page-list",
    method: "get",
    params: params
  });
}

// 获取活动详情
export function apiGetActivityDetail(params) {
  return service({
    url: "/v1/activity/detail",
    method: "get",
    params: params
  });
}

// 获取角色列表
export function apiGetBattleRoleList(params) {
  return service({
    url: "/v1/bdRoster/query-role-list",
    method: "get",
    params: params
  });
}

// 抽卡列表
export function apiCardPoolQueryGachaList(params) {
  return service({
    url: "/v1/cardPool/queryGachaList",
    method: "get",
    params: params
  });
}

// 获取阵容详情
export function apiGetBattleDetail(params) {
  return service({
    url: "/v1/userBattle/detail",
    method: "get",
    params: params,
    successToast: false,
    errorToast: false
  });
}

// 抽卡记录
export function apiCardPoolGachaCardResult(params) {
  return service({
    url: "/v1/cardPool/gachaCard/result",
    method: "get",
    params: params
  });
}

// 添加阵容配置内容
export function apiAddBattle(params) {
  return service({
    url: "/v1/protected/userBattle/add",
    method: "post",
    data: params,
    successToast: true,
    errorToast: true
  });
}

// 编辑阵容配置内容
export function apiEditBattle(params) {
  return service({
    url: "/v1/protected/userBattle/edit",
    method: "post",
    data: params,
    successToast: true,
    errorToast: true
  });
}

// 抽卡记录清除
export function apiCardPoolGachaCardClear(params) {
  return service({
    url: "/v1/cardPool/gachaCard/clear",
    method: "post",
    data: params
  });
}

// 抽卡开始
export function apiCardPoolGachaCard(params) {
  return service({
    url: "/v1/cardPool/gachaCard",
    method: "post",
    data: params
  });
}

/** 图鉴语音对话发送文本消息 */
export function apiContentTalkSendMessage(data) {
  return service({
    url: "/v1/protected/contentTalk/sendMessage",
    method: "post",
    data
  });
}

/** 图鉴语音对话角色详情 */
export function apiContentTalkDetail(params) {
  return service({
    url: "/v1/protected/contentTalk/detail",
    method: "get",
    params
  });
}

/** 图鉴语音对话消息记录 */
export function apiContentTalkList(params) {
  return service({
    url: "/v1/protected/contentTalk/talkPageList",
    method: "get",
    params
  });
}
